import http from './httpService';
import * as Axios from 'axios';

export function getAllSubProcesses(processId) {
  return http.get(`/subprocesses?processId.equals=${processId}`);
}

export function getRiskEstimations(frequencyOccurenceRiskId,financialPerformanceId) {
  return http.get(`risk-estimations?financialPerformanceId.equals=${financialPerformanceId}&frequencyOccurenceRiskId.equals=${frequencyOccurenceRiskId}`);
}

export function getPotentialRisk(potentialRiskId){
  return http.get(`/risks/${potentialRiskId}`);
}

export function addPotentialRisk(data, files) {
  const formData = new FormData();
  formData.append('riskDTO', JSON.stringify(data));
  for (let i=0; i<files.length; i++) {
    formData.append('files', files[i]);
  }
  return Axios({
    method: 'post',
    url: '/risks',
    data: formData,
    headers: {'Content-Type': 'multipart/form-data;'},
  });
}

export function editPotentialRisk(data, files) {
  const formData = new FormData();
  formData.append('riskDTO', JSON.stringify(data));
  for (let i=0; i<files.length; i++) {
    formData.append('files', files[i]);
  }

  return Axios({
    method: 'put',
    url: '/risks',
    data: formData,
    headers: {'Content-Type': 'multipart/form-data;'},
  });
}

export function getRiskFile(fileId, fileName) {
  return Axios({
    url: `/file/download/${fileId}`, //your url
    method: 'get',
    responseType: 'blob', // important
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    // link.target = "_blank"
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  });
}


export function getAllSubCauses(id) {
  return http.get(`risk-sub-causes?riskCauseId.equals=${id}`);
}


export function getMethodology(){
  return http.get(`/methodologies`);
}


export function getDepartment(id){
  return http.get(`/departments?id.equals=${id}`);
}